import { Form, Input, InputNumber, Tooltip } from "antd";
import { memo } from "react";

import NewSvg from "../../../../../assets/icons/new.svg";
import SquarePurple from "../../../../../assets/icons/squarer-purple.svg";
import VectorMinus from "../../../../../assets/icons/vector-minus.svg";
import BuildingSVG from "../../../../../assets/icons/building-purple.svg";
import DocumentIconSvg from "../../../../../assets/icons/document-icon.svg";

import { CR001AmountRelateHandler } from "../handler/HandlerImpl";
import REGEX from "../../../../../common/constants/REGEX";
import MESSAGE from "../../../../../common/constants/MESSAGE";
import { onBlurTrimFormItem } from "../../../../../common/helpers/typeInput";
import helpers from "../../../../../common/helpers/common";
import COMMON from "../../../../../common/constants/COMMON";
import UploadEvidenceComponent from "../../../../../common/components/common-form-item-cm/upload-evidence";
import UploadFileCRComponent from "../../../../../common/components/upload-cr";
const { Item } = Form;

interface props {
  handler: CR001AmountRelateHandler;
}

const MESSAGE_REQUIRED = "";
const MAX_LENGTH_TEXT = 30;
const MIN_INPUT_NUMBER = 0;
const REQUIRED_INPUT = false;

const Material = ({ handler }: props) => {
  return (
    <div className="cr001-cost-registration">
      <div className="cr001-cost-registration-title bg-title-row padding-tb-15 border-bottom">
        <img src={NewSvg} alt="" />
        <span className="text-bold-14">材料費登録</span>
      </div>
      {handler.isEdit && (

        <div style={{ height: 55, padding: "16px 12px", borderBottom: "1px solid #e9edf2" }}>
          <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handler.handleAddMaterialCost}>
            <img alt="" src={SquarePurple} />
            <span className="text-bold-14" style={{ marginLeft: '10px', color: '#605bff', fontWeight: 700 }}>項目追加</span>
          </div>
        </div>

      )}
      <div className="cr003-table-wrapper">
        <table className="cr003-table cr003-table-material">
          <thead>
            <tr>
              <th>項目名</th>
              <th>業者名</th>
              <th>見積金額（円）</th>
              <th>原価金額（円）</th>
              <th>予算金額（円）</th>
              <th>発注金額（円）</th>
              <th>ファイル</th>
            </tr>
          </thead>
          <tbody>

            {handler.materialCostList?.map((materialCost: any) => {
              return (
                <tr key={`materialCost${materialCost.key}`} className="cr001-icon-rotate">
                  <td>
                    {handler.isEdit ? (
                      <div className="cr001-cr-item-bonus" style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          alt=""
                          src={VectorMinus}
                          onClick={() =>
                            handler.handleDeleteMaterialCost(materialCost.key)
                          }
                          className="cr001-margin-icon"
                        />
                        <Item
                          name={[`materialCost${materialCost.key}`, "materialName"]}
                          rules={[
                            () => ({
                              validator(_, value) {
                                if (value && value !== "") {
                                  // CHECK INPUT VIETNAMESE
                                  if (!REGEX.NOT_VIETNAM.test(value)) {
                                    return Promise.reject(
                                      new Error(MESSAGE.MESSAGE_INPUT_INVALID)
                                    );
                                  }
                                  if (value?.length > MAX_LENGTH_TEXT) {
                                    return Promise.reject(new Error(""));
                                  }
                                  return Promise.resolve();
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input
                            maxLength={MAX_LENGTH_TEXT}
                            className="input-cr001"
                            style={{ width: 100 }}
                            autoComplete="off"
                            onChange={helpers.preventInputJapanese}
                            onBlur={() =>
                              onBlurTrimFormItem(handler.formAmount, [
                                `materialCost${materialCost.key}`,
                                "materialName",
                              ])
                            }
                          />
                        </Item>
                      </div>
                    ) : (
                      <Tooltip
                        title={
                          handler.listTooltip?.includes(
                            `tooltip${materialCost.key}material`
                          )
                            ? materialCost?.materialName
                            : ""
                        }
                        getPopupContainer={(trigger: any) => trigger.parentNode}
                        overlayInnerStyle={{ color: "#fff", margin: "0 -4%" }}
                      >
                        <span
                          className="cr-text-long-tooltip text-tooltip"
                          id={`tooltip${materialCost.key}material`}
                        >
                          {materialCost?.materialName}
                        </span>
                      </Tooltip>
                    )}
                  </td>
                  <td
                    className={`text-error ${handler.requiredMaterial?.includes(materialCost?.key)
                      ? "border-error"
                      : ""
                      }`}
                  >
                    {handler.isEdit ? (
                      <div className={`cr001-choose-building`}>
                        <div
                          className="cr001-choose-building-content"
                          onClick={() =>
                            handler.handleViewModalExternal(
                              `materialCost${materialCost.key}`,
                              materialCost?.materialCostCompany,
                              "materialSuppliers"
                            )
                          }
                        >
                          <Tooltip
                            title={
                              handler.listTooltip.includes(
                                `tooltip${materialCost.key}materialCompany`
                              )
                                ? materialCost?.materialCostCompany?.name
                                : ""
                            }
                          >
                            <span
                              className="text-tooltip color-purple"
                              id={`tooltip${materialCost.key}materialCompany`}
                            >
                              {materialCost?.materialCostCompany?.name
                                ? materialCost?.materialCostCompany?.name
                                : ""}
                            </span>
                          </Tooltip>
                          <img src={BuildingSVG} alt="" />
                        </div>
                      </div>
                    ) : (
                      <Tooltip
                        title={
                          handler.listTooltip.includes(
                            `tooltip${materialCost.key}materialCompany`
                          )
                            ? materialCost?.materialCostCompany?.name
                            : ""
                        }
                        getPopupContainer={(trigger: any) => trigger.parentNode}
                        overlayInnerStyle={{ color: "#fff", margin: "0 -4%" }}
                      >
                        <span
                          className="cr001-subcontract-company-name text-tooltip"
                          id={`tooltip${materialCost.key}materialCompany`}
                        >
                          {materialCost?.materialCostCompany?.name}
                        </span>
                      </Tooltip>
                    )}
                  </td>
                  <td className="color-gray">
                    {handler.isEdit ? (
                      <Item
                        rules={[
                          {
                            required: REQUIRED_INPUT,
                            message: MESSAGE_REQUIRED,
                          },
                        ]}
                        name={[`materialCost${materialCost.key}`, "estimateMoney"]}
                      >
                        <InputNumber
                          controls={false}
                          maxLength={COMMON.MAX_INPUT_NUMBER}
                          max={COMMON.MAX_NUMBER_VALUE}
                          min={MIN_INPUT_NUMBER}
                          className="input-cr001"
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                        />
                      </Item>
                    ) : (
                      handler.checkFormatValue(
                        materialCost?.estimateMoney,
                        false,
                        true
                      )
                    )}
                  </td>
                  <td className="color-gray">
                    {handler.isEdit ? (
                      <Item
                        rules={[
                          {
                            required: REQUIRED_INPUT,
                            message: MESSAGE_REQUIRED,
                          },
                        ]}
                        name={[`materialCost${materialCost.key}`, "costMoney"]}
                      >
                        <InputNumber
                          controls={false}
                          maxLength={COMMON.MAX_INPUT_NUMBER}
                          max={COMMON.MAX_NUMBER_VALUE}
                          min={MIN_INPUT_NUMBER}
                          className="input-cr001"
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                        />
                      </Item>
                    ) : (
                      handler.checkFormatValue(materialCost?.costMoney, false, true)
                    )}
                  </td>
                  <td className="color-gray">
                    <div className="cr003-item-percent">
                      {handler.isEdit ? (
                        <>
                          <Item
                            rules={[
                              {
                                required: REQUIRED_INPUT,
                                message: MESSAGE_REQUIRED,
                              },
                            ]}
                            name={[`materialCost${materialCost.key}`, "budgetMoney"]}
                          >
                            <InputNumber
                              controls={false}
                              maxLength={COMMON.MAX_INPUT_NUMBER}
                              max={COMMON.MAX_NUMBER_VALUE}
                              min={MIN_INPUT_NUMBER}
                              className="input-cr001"
                              formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                            />
                          </Item>
                          <span className="text-percent-input" >
                            {handler.checkFormatValue(
                              materialCost?.budgetMoneyPercent,
                              true,
                              true
                            )}
                          </span>
                        </>
                      ) : (
                        handler.checkFormatValue(
                          materialCost?.budgetMoney,
                          false,
                          true
                        ) +
                        " " +
                        handler.checkFormatValue(
                          materialCost?.budgetMoneyPercent,
                          true,
                          true
                        )
                      )}
                    </div>
                  </td>
                  <td className="color-gray">
                    <div className="cr003-item-percent">
                      {handler.isEdit ? (
                        <>
                          <Item
                            rules={[
                              {
                                required: REQUIRED_INPUT,
                                message: MESSAGE_REQUIRED,
                              },
                            ]}
                            name={[`materialCost${materialCost.key}`, "orderMoney"]}
                          >
                            <InputNumber
                              controls={false}
                              maxLength={COMMON.MAX_INPUT_NUMBER}
                              max={COMMON.MAX_NUMBER_VALUE}
                              min={MIN_INPUT_NUMBER}
                              className="input-cr001"
                              formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                            />
                          </Item>
                          <span className="text-percent-input" >
                            {handler.checkFormatValue(
                              materialCost?.orderMoneyPercent,
                              true,
                              true
                            )}
                          </span>
                        </>
                      ) : (
                        handler.checkFormatValue(
                          materialCost?.orderMoney,
                          false,
                          true
                        ) +
                        " " +
                        handler.checkFormatValue(
                          materialCost?.orderMoneyPercent,
                          true,
                          true
                        )
                      )}
                    </div>
                  </td>
                  <td className="color-gray">
                    {handler.isEdit ? (
                      <UploadFileCRComponent
                        nameForm={[
                          `materialCost${materialCost.key}`,
                          "documentMaterial",
                        ]}
                        fileNameDefault={materialCost.document}
                        form={handler.formAmount}
                        afterClear={() =>
                          handler.afterClear(
                            [`materialCost${materialCost.key}`, "documentMaterial"],
                            handler.listIndirect,
                            "materialCost"
                          )
                        }
                      />
                    ) : materialCost?.document?.length != 0 ? (
                      <div
                        className="button-style"
                        onClick={() => {
                          handler.handleViewFile(materialCost, "material");
                        }}
                      >
                        <img src={DocumentIconSvg} alt="" />
                      </div>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td className="color-gray" style={{ fontWeight: 400 }}>合計金額</td>
              <td></td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalMaterialCost?.estimateMoney,
                  false,
                  true
                )}
              </td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalMaterialCost?.costMoney,
                  false,
                  true
                )}
              </td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalMaterialCost?.budgetMoney,
                  false,
                  true
                )}{" "}
                {handler.checkFormatValue(
                  handler.totalMaterialCost?.budgetMoneyPercent,
                  true,
                  true
                )}
              </td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalMaterialCost?.orderMoney,
                  false,
                  true
                )}{" "}
                {handler.checkFormatValue(
                  handler.totalMaterialCost?.orderMoneyPercent,
                  true,
                  true
                )}
              </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default memo(Material);
